module.exports = __webpack_public_path__ + "img/resources.078b7d6e.png";